import { Paper, Grid } from "@material-ui/core";
import { InputOptionMaster, MasterButton } from "App/Component/ui";
import {
  STYLE_DEFAULT_MASTER,
  TYPE_INSTANCE2,
  DISABLED_BUTTON_SUBMIT,
} from "App/constants";
import { useSelectOption } from "App/hooks";
import { isNull, defaultToastError } from "App/utils/helpers";
import React, { useState } from "react";
import { useMenuAccess } from "./helpers";

const LOAD_ACCESS = {
  label: "LOAD ACCESS",
  color: "green",
  state: false,
};

function FormUserAccess({
  formData,
  setFormData,
  setRowsUserAccess,
  fetchDataUserAccess,
}) {
  const classes = STYLE_DEFAULT_MASTER();
  const [disabled, setDisabled] = useState(LOAD_ACCESS);

  const role = useSelectOption(
    true,
    "/users/listrole",
    TYPE_INSTANCE2,
    "id",
    "nama_role"
  );

  const { menuAccessList, menuAccessSelect } = useMenuAccess();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(formData.access_code) || isNull(formData.role_id)) {
        defaultToastError("Access dan Role tidak boleh kosong!");
        setDisabled(LOAD_ACCESS);
      } else {
        await fetchDataUserAccess();
        setDisabled(LOAD_ACCESS);
        const detailMenuAccess = menuAccessList.filter(
          (item) => item.access_code === formData.access_code
        );

        if (detailMenuAccess.length > 0) {
          setFormData({
            ...formData,
            access_url: isNull(detailMenuAccess[0].url)
              ? ""
              : detailMenuAccess[0].url,
            access_type_service: isNull(detailMenuAccess[0].type_service)
              ? ""
              : detailMenuAccess[0].type_service,

            access_label: isNull(detailMenuAccess[0].label)
              ? ""
              : detailMenuAccess[0].label,

            access_value: isNull(detailMenuAccess[0].value)
              ? ""
              : detailMenuAccess[0].value,
          });
        }
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message);
      setDisabled(LOAD_ACCESS);
    }
  };

  return (
    <Paper
      classes={classes.root}
      style={{
        padding: "1rem",
      }}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={5}>
            <InputOptionMaster
              name='role_id'
              label='ROLE'
              id='role_id'
              withSearch={true}
              data={role}
              value={formData.role_id}
              labelValue={formData.role_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    role_id: null,
                    role_name: "Pilih Role",
                  });
                } else {
                  setFormData({
                    ...formData,
                    role_id: e.value,
                    role_name: e.label,
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={5}>
            <InputOptionMaster
              name='access_code'
              label='ACCESS'
              id='access_code'
              withSearch={true}
              data={menuAccessSelect}
              value={formData.access_code}
              labelValue={formData.access_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    access_code: null,
                    access_name: "Pilih Access",
                  });
                } else {
                  setFormData({
                    ...formData,
                    access_code: e.value,
                    access_name: e.label,
                  });
                }
              }}
            />
          </Grid>

          <Grid item sm={2}>
            <div
              style={{
                marginTop: "1.5rem",
              }}>
              <MasterButton
                style={{
                  width: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  padding: "0.55rem",
                }}
                type='submit'
                color={disabled.color}
                name={disabled.label}
                size='md'
              />
            </div>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
}

export default FormUserAccess;
